import { useMediaQuery, useTheme } from '@mui/material';
import { ChatMessage } from '../ChatComponents';
import { BotMessage } from './BotMessage';
import { UserMessage } from './UserMessage';
import React, { CSSProperties } from 'react';

interface ChatBubbleProps {
  message: ChatMessage;
  onContentUpdate?: () => void;
  onFeedbackSubmit?: (
    messageId: string,
    feedbackType: 'thumbs_up' | 'thumbs_down',
    feedback: string
  ) => void;
  feedbackConfirmations?: { [messageId: string]: 'thumbs_up' | 'thumbs_down' };
  conversationId?: string | null;
  userId?: string;
  streamState?: {
    event: 'start' | 'message' | 'memory_updated' | 'new_conversation' | 'end';
    loading: boolean;
    loadingMessage?: string;
  };
  isLastMessage?: boolean;
}

export const ChatBubble = React.memo<ChatBubbleProps>(function ChatBubble({
  message,
  onContentUpdate,
  onFeedbackSubmit,
  feedbackConfirmations,
  conversationId,
  userId,
  streamState,
  isLastMessage = false,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const commonSx: CSSProperties = {
    fontFamily: 'DM Sans, sans-serif',
    fontSize: isMobile ? 14 : 16,
  };
  return message.sender === 'bot' ? (
    <BotMessage
      message={message}
      onContentUpdate={onContentUpdate}
      onFeedbackSubmit={onFeedbackSubmit}
      feedbackConfirmations={feedbackConfirmations}
      conversationId={conversationId}
      userId={userId}
      streamState={streamState}
      isLastMessage={isLastMessage}
      sx={commonSx}
    />
  ) : (
    <UserMessage message={message} sx={commonSx} />
  );
});
